import { render, staticRenderFns } from "./ChoiceButtonField.vue?vue&type=template&id=acd88214"
import script from "./ChoiceButtonField.vue?vue&type=script&lang=ts"
export * from "./ChoiceButtonField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports